module.exports = __webpack_public_path__ + "static/img/worth2.8ee47d87.png";